import { render } from "./RemoteInstanceEditorWrapper.vue?vue&type=template&id=efbe6c44"
import script from "./RemoteInstanceEditorWrapper.vue?vue&type=script&lang=js"
export * from "./RemoteInstanceEditorWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__